export default __webpack_public_path__ + "static/media/reimagined-home.43c6d37a.gif";